function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 44.53V3.47A3.48 3.48 0 013.49 0h41.03A3.48 3.48 0 0148 3.47v41.06A3.48 3.48 0 0144.52 48H3.49A3.48 3.48 0 010 44.53zm44.63 0V3.47a.11.11 0 00-.11-.11H3.49a.11.11 0 00-.12.11v41.06c0 .06.05.11.12.11h41.03c.06 0 .1-.05.1-.1zM7.06 34.52c-.7-.6-.78-1.67-.17-2.37L16.9 20.59a1.7 1.7 0 012.17-.33l9.07 5.58 7.71-8.92-.8.1a1.68 1.68 0 11-.44-3.33l5.18-.67c1.01-.13 1.9.66 1.9 1.67v5.08a1.69 1.69 0 01-3.37 0v-.55l-8.56 9.9a1.7 1.7 0 01-2.17.33l-9.07-5.58-9.09 10.48c-.6.7-1.67.78-2.38.17z"
})));